/*
 * Copyright (c) 2024 Helvia Technologies PC <contact@helvia.io>
 */

import { decodeJWT } from '../decodeJWT';

/**
 * Sees whether a JWT is of a specific organization
 *
 * @param {String} token The token string to parse.
 * @param {String} organizationId The organization ID to check against the token claims.
 * @returns {Boolean} Whether the token is of a specific organization
 */
export const isTokenOfOrganization = (token, organizationId) => {
  return decodeJWT(token).organizationId === organizationId;
};
